var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.768 7.5c.28-.492.432-1.058.432-1.667C13.2 3.992 11.768 2.5 10 2.5c-1.768 0-3.2 1.492-3.2 3.333 0 .609.152 1.175.432 1.667H5.2c-.76 0-1.4.558-1.56 1.3C2.032 15.475 2 15.65 2 15.833c0 .917.72 1.667 1.6 1.667h12.8c.88 0 1.6-.75 1.6-1.667 0-.183-.032-.358-1.64-7.033-.16-.742-.8-1.3-1.56-1.3h-2.032zM8.4 5.833c0-.916.72-1.666 1.6-1.666.88 0 1.6.75 1.6 1.666 0 .917-.72 1.667-1.6 1.667-.88 0-1.6-.75-1.6-1.667z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.ee4fc16d5289858c8754975b13fc3d56.svg";
export { ForwardRef as ReactComponent };